declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../../models/api_request_model';
import { SpinnerService } from '../../../../../services/spinner.service';
import { AppData } from '../../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

import { DBOperation } from '../../../../../enums/enum';
import { ActorContactInfoRequest } from '../../../../../models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../../services/hcp.service';
import { ChangePasswordRequest } from '../../../../../models/login/changepassword.model';
import { ActorService } from '../../../../../services/actor.service';

import * as alertFunctions from '../../../../../../shared/data/sweet-alerts';
//import MD5 from 'src/app/shared/utils/md5';
import { NGXToastrService } from '../../../../../../shared/services/toastr.service';

@Component({
  selector: 'ngbchangepassword',
  templateUrl: './changepassword.modal.html',
  styleUrls: ['./changepassword.modal.scss']
})

export class NgbChangePasswordModal implements OnInit {
  @ViewChild('f') IdentitiesForm: NgForm;


  @Input() UserName: string;
  CurrentChangePasswordRequest: ChangePasswordRequest;

  @Input() IsRelogin: boolean



  public ApiResData: ApiResponseModel;

  public isRequesting: boolean = false;

  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService,
    private router: Router, private route: ActivatedRoute, private actorservice: ActorService, private tosterservice: NGXToastrService) { }
  ngOnInit() {

    this.CurrentChangePasswordRequest = new ChangePasswordRequest();
    this.CurrentChangePasswordRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentChangePasswordRequest.UserName = this.UserName;

  }



  onChangePassword() {

    if (this.CurrentChangePasswordRequest.NewPassword === this.CurrentChangePasswordRequest.ReEnterPassword) {

      if (AppData.IsEncriptFromClientSide == true) {
        this.CurrentChangePasswordRequest.NewPassword =(this.CurrentChangePasswordRequest.NewPassword);
        this.CurrentChangePasswordRequest.ReEnterPassword =(this.CurrentChangePasswordRequest.ReEnterPassword);
        this.CurrentChangePasswordRequest.IsEncriptFromClient = true;
      }

      this.StartRefreshing();

      this.actorservice.xChangePassword(this.CurrentChangePasswordRequest)
        .subscribe((result) => {
          this.ApiResData = result;
          if (!this.ApiResData.hasError) {

            //alertFunctions.AlertParam("Change Password Successfully...!");
            this.activeModal.close();
            this.stopRefreshing();
              if (this.IsRelogin === true) {
                //alertFunctions.AlertParam("Password is Change Successfully Please Login again With New Password...!");
                this.tosterservice.ToasterSuccessAlertParam('Password  Changed Successfully Please Login again With New Password.....!');
                this.router.navigate(['login']);;
              }
              else {
                //alertFunctions.AlertParam("Password is Change Successfully...!");
                this.tosterservice.ToasterSuccessAlertParam('Password  Changed Successfully.....!');

              }
            

           
          }
          else {
            this.stopRefreshing();
            if (this.ApiResData.ErrorData != "") {

              alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            }
            else {
              alertFunctions.AlertParam('Change Password Failed Due to Internal Error.... Please Contact Admin..');
            }

          }


        },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


        );
    }
    else {
      alertFunctions.AlertParam('NewPassword is MissMatch With ReEnterPassword ');
    }



  }




  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }




}
